import classNames from 'classnames';
import { Skeleton } from '@medifind/shared-basic-components';
import styles from './CardAddress.module.scss';

const DistanceText = ({ distance }) => {
  return <span>&nbsp;({distance})</span>;
};

const CardAddress = ({ data, distance }) => {
  if (!data) {
    return <Skeleton />;
  }
  if (!data?.address) {
    return null;
  }
  const { addressLine1, addressLine2, location } = data?.address || {};

  return (
    <div className={classNames(styles['card-address'])}>
      <div className={classNames(styles['card-address__content'])}>
        {addressLine1 ? (
          <div>
            {addressLine1}
            {addressLine2 ? `, ${addressLine2}` : ''}
            {location ? <>,&nbsp;</> : ''}
          </div>
        ) : null}
        <div>{location ? <>{location}&nbsp;</> : ''}</div>
      </div>
      {distance ? <DistanceText distance={distance} /> : ''}
    </div>
  );
};

export { CardAddress as default, CardAddress };
